import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Alert from "@mui/material/Alert";
import { CircularProgress } from '@material-ui/core';
import axios from "axios";
import "../styling/sidebar.css";
import "../styling/expensepop.css";
import GetUser from "../services/get-user";

export default function SUPopup(props) {
  const [name, setName] = useState(props.keydata.name);
  const [amount, setAmount] = useState(props.keydata.amount.split(",").join(''));
  const [saleID, setsaleID] = useState(props.keydata._id);
  const [note, setNote] = useState(props.keydata.note);
  const [usedate, setUseDate] = useState(new Date(props.keydata.realDate));
  const [customer, setCustomer] = useState(props.keydata.customer);
  const [totalFees,setTotalFees] = useState(props.keydata.fee);
  const [isFeeChange,setIsFeeChange] = useState(true);
  const [isUpdateFeeValue,setIsUpdateFeeValue] = useState(false);
  const [allFeeTotal,setAllFeeTotal] =  useState<any>("");
  const [typeOfFees, setTypeOfFees] = useState<any>({
    listingFees: props.keydata?.listfee ?props.keydata.listfee:0,
    commision: 0,
    shippingFees: props.keydata?.shipfee ?props.keydata.shipfee:0,
  });
  const [checkNegativeValue, setCheckNegativeValue] = useState<any>({
    checkListingFees: false,
    checkCommision: false,
    checkShippingFees: false,
  });
  const [loading, setLoading] = useState(false);

  const countTotalFees = (event) => {
    setIsUpdateFeeValue(true);
    if (event.target.id === "Shipping Fee") {
      setCheckNegativeValue({
        ...checkNegativeValue,
        checkShippingFees: event.target.value < 0,
      });
    }
    if (event.target.id === "Marketplace Fee") {
      setCheckNegativeValue({
        ...checkNegativeValue,
        checkCommision: event.target.value < 0,
      });
    }
    if (event.target.id === "Listing Fees") {
      setCheckNegativeValue({
        ...checkNegativeValue,
        checkListingFees: event.target.value < 0,
      });
    }

    if (event.target.value === "") {
      setTypeOfFees({
        ...typeOfFees,
        [event.target.name]: null,
      });
    } else {
      setTypeOfFees({
        ...typeOfFees,
        [event.target.name]: Number(event.target.value),
      });
    }
  };  
  const user = GetUser();

  function validateForm() {
    return name.length > 0 && customer.length > 0 && amount >= 0 && amount!=null;
  }

  const handleChange = (event) => {
    const { value } = event.target;
    if (value.match(/\./g)) {
      const [, decimal] = value.split(".");
      if (decimal?.length > 2) {
        return;
      }
    }
    value === "" ? setAmount(null) :setAmount(Number(value));
  };

  const handleFeesChange = (event) => {
    const { value } = event.target;
    if (value.match(/\./g)) {
      const [, decimal] = value.split(".");
      if (decimal?.length > 2) {
        return;
      }
    }
    value === "" ? setTotalFees("") :setTotalFees((value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    try {
      //'http://localhost:8080/income/add_income'
      //return axios.post('http://localhost:8080/sale/update_sale', {
      return axios
        .post("https://sotira-back-test.herokuapp.com/sale/update_sale", {
          userID: user.userID,
          saleID: saleID,
          name: name,
          date: usedate,
          amount: amount,
          fee: (isFeeChange) ? (totalFees === "" ? 0 : totalFees) : allFeeTotal,
          customer: customer,
          note: note,
        })
        .then(() => {
          sessionStorage.setItem("option", "sales");
          setLoading(false);
          props.closeUpdateModel(false);
          props.setReloadTableData((prevState)=>!prevState);
          props.setReloadAPI((prevState)=>!prevState);

        });
    } catch (e) {
      setLoading(false)
    }
  };

  useEffect(()=>{
    const { listingFees, commision, shippingFees } = typeOfFees;
    const updatedTotalFees = (listingFees + commision + shippingFees).toFixed(2);
    isUpdateFeeValue && setIsFeeChange(false);
    setAllFeeTotal(updatedTotalFees);
  },[typeOfFees])

  const disableScroll = (e) => {
    const isFocused = document.activeElement === e.target
    if (isFocused) {
      e.target.blur()
      setTimeout(() => {
        e.target.focus()
      })
    }
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="name" className="form-group required">
        <Form.Label className="control-label"> Product Name </Form.Label>
        <Form.Control
          autoFocus
          type="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Form.Group>

      <Form.Group controlId="amount" className="form-group required">
      <Form.Label className="control-label"> Amount $ </Form.Label>
        <div className="d-flex">
        <span className="font-currency mr-2 mt-1">$</span>
          <Form.Control
          autoFocus
          type="number"
          step={0.01}
          onWheel={disableScroll}
          value={amount}
          onChange={handleChange}
        />
        </div>
      </Form.Group>

      <Form.Group controlId="date">
        <Form.Label> Date Sold </Form.Label>
        <DatePicker
          selected={usedate}
          maxDate={new Date()}
          onChange={(date) => setUseDate(date)}
          showTimeSelect
          dateFormate="Pp"
          className="date-picker-input"
        />
      </Form.Group>

      <Form.Group controlId="cust" className="form-group required">
        <Form.Label className="control-label"> Customer Name </Form.Label>
        <Form.Control
          autoFocus
          type="cust"
          value={customer}
          onChange={(e) => setCustomer(e.target.value)}
        />
      </Form.Group>

      <Form.Group controlId="Listing Fees" className="mb-2 mt-2">
        <Form.Label className="control-label"> Listing Fees </Form.Label>
        <Form.Control
          autoFocus
          name="listingFees"
          type="number"
          step={0.01}
          onWheel={disableScroll}
          value={typeOfFees.listingFees}
          onChange={(e) => countTotalFees(e)}
        />
      </Form.Group>
      {checkNegativeValue.checkListingFees && (
        <Alert severity="error" className="pt-0 pl-0">
          Please Enter Positive Value!
        </Alert>
      )}
      <Form.Group controlId="Marketplace Fee" className="mb-2 mt-2">
        <Form.Label className="control-label"> Marketplace Fee </Form.Label>
        <Form.Control
          autoFocus
          type="number"
          name="commision"
          onWheel={disableScroll}
          step={0.01}
          value={typeOfFees.commision}
          onChange={(e) => countTotalFees(e)}
        />
      </Form.Group>
      {checkNegativeValue.checkCommision && (
        <Alert severity="error" className="pt-0 pl-0">
          Please Enter Positive Value!
        </Alert>
      )}
      <Form.Group controlId="Shipping Fee" className="mb-2 mt-2">
        <Form.Label className="control-label"> Shipping Fee </Form.Label>
        <Form.Control
          autoFocus
          type="number"
          step={0.01}
          name="shippingFees"
          onWheel={disableScroll}
          value={typeOfFees.shippingFees}
          onChange={(e) => countTotalFees(e)}
        />
      </Form.Group>
      {checkNegativeValue.checkShippingFees && (
        <Alert severity="error" className="pt-0 pl-0">
          Please Enter Positive Value!
        </Alert>
      )}

      <Form.Group controlId="fee" className="form-group required mt-2">
        <Form.Label className="control-label">
          {" "}
          Total Fees $ (Listing Fee, Shipping, Marketplace Fee){" "}
        </Form.Label>
        <Form.Control
          autoFocus
          type="number"
          step={0.01}
          placeholder="0.00"
          value={((parseFloat(totalFees.split(",").join("")) >= 0) && isFeeChange)? parseFloat(totalFees.split(",").join("")) : allFeeTotal}
          onWheel={disableScroll}
          onChange={(e) => {
            setAllFeeTotal("");
            setIsFeeChange(true);
            handleFeesChange(e)
          }}
        />
      </Form.Group>

      <Form.Group controlId="note">
        <Form.Label> Note </Form.Label>
        <Form.Control
          autoFocus
          type="note"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </Form.Group>

      <Button block size="sm" type="submit" disabled={!validateForm()}>
      {loading ?
        <><CircularProgress className="file-loader mr-3" />Updating</>
        : ' Edit Sale'
      }   
      </Button>
    </Form>
  );
}
